<template>
    <div class="w-100 d-flex align-items-center">
        <CSpinner color="dark"/> <span class="py-2 px-3"><strong>PLEASE WAIT</strong></span>
    </div>
</template>
<script>
export default {
  name: 'LoadingView'
}
</script>
